import { Link } from "react-router-dom";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { Camera, Mail, FileText, Shield, BookOpen, DollarSign, Home, Image, CreditCard } from "lucide-react";

const Footer = () => {
  const { settings } = useSiteSettings();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/50 bg-card/30">
      <div className="container mx-auto max-w-6xl px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              {settings.logo_url ? (
                <img 
                  src={settings.logo_url} 
                  alt="Logo" 
                  className="h-5 w-5 object-contain dark:invert"
                />
              ) : (
                <Camera className="h-5 w-5 text-primary" />
              )}
              <span className="font-semibold">{settings.site_name}</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Build your perfect camera rig with intelligent compatibility checking.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-medium mb-3 text-sm">Product</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/" className="hover:text-foreground transition-colors flex items-center gap-1.5">
                  <Home className="h-3.5 w-3.5" />
                  Home
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-foreground transition-colors flex items-center gap-1.5">
                  <Image className="h-3.5 w-3.5" />
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-foreground transition-colors flex items-center gap-1.5">
                  <CreditCard className="h-3.5 w-3.5" />
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/rate-finder" className="hover:text-foreground transition-colors flex items-center gap-1.5">
                  <DollarSign className="h-3.5 w-3.5" />
                  Rate Finder
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-medium mb-3 text-sm">Support</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/docs" className="hover:text-foreground transition-colors flex items-center gap-1.5">
                  <BookOpen className="h-3.5 w-3.5" />
                  Docs
                </Link>
              </li>
              <li>
                <Link to="/support" className="hover:text-foreground transition-colors flex items-center gap-1.5">
                  <Mail className="h-3.5 w-3.5" />
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-medium mb-3 text-sm">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/privacy" className="hover:text-foreground transition-colors flex items-center gap-1.5">
                  <Shield className="h-3.5 w-3.5" />
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-foreground transition-colors flex items-center gap-1.5">
                  <FileText className="h-3.5 w-3.5" />
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-border/30">
          <p className="text-center text-sm text-muted-foreground">
            © {currentYear} {settings.site_name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
